module.exports = __webpack_public_path__ + "img/news2-6.d58fe894.png";